import {computedFrom, observable, TaskQueue} from 'aurelia-framework';
import {CurrentGroup} from '../../../../../services/group/current-group';
import {GroupService} from '../../../../../services/group/group-service';
import {inject} from 'aurelia-property-injection';
import {get} from 'lodash';

export class GroupReportCustomElement {

  @inject(TaskQueue) taskQueue;
  @inject(CurrentGroup) currentGroup;
  @inject(GroupService) groupService;

  reports = [];
  @observable selectedReport;
  @observable onReportWindow = false;

  afterConstructor() {
    this.getAvailableReports();
  }

  getAvailableReports() {
    this.currentGroup.onReady().then(() => {
      let {response} = this.groupService.reports(this.currentGroup.state.groupId);
      response.then(data => this.reports = data.reports);
    });
  }

  selectReportItem(report) {
    this.selectedReport = this.selectedReport !== report ? report : null;
  }

  showReport() {
    this.onReportWindow = true;
    this.taskQueue.queueMicroTask(() => this.selectedReport = null);
  }

  showPane() {
    this.onReportWindow = false;
  }

  @computedFrom('onReportWindow')
  get reportUrl() {
    return this.onReportWindow && get(this.selectedReport, 'reportUrl') || '';
  }

  @computedFrom('reports')
  get isReportsAvailable() {
    return this.reports.length > 0;
  }
}
